'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.isLoadedDetail = isLoadedDetail;
exports.isProminentLoaded = isProminentLoaded;
exports.isSuggestLoaded = isSuggestLoaded;
exports.isFeaturedLoaded = isFeaturedLoaded;
exports.unSetDetail = unSetDetail;
exports.getProminent = getProminent;
exports.getSuggest = getSuggest;
exports.getHomeService = getHomeService;
exports.loadServiceOfHomeService = loadServiceOfHomeService;
exports.getActiveBooking = getActiveBooking;
exports.getGeneralView = getGeneralView;
exports.getFeatured = getFeatured;
exports.getReview = getReview;
exports.getShopData = getShopData;
exports.resetShopData = resetShopData;
exports.getShopDataServer = getShopDataServer;
exports.checkBooking = checkBooking;
exports.getReviewSuggest = getReviewSuggest;
exports.getBooking = getBooking;
exports.requestBooking = requestBooking;
exports.likeShop = likeShop;
exports.bookmarkShop = bookmarkShop;
exports.newReview = newReview;
exports.submitReply = submitReply;
exports.loadDistrict = loadDistrict;
exports.createShop = createShop;
exports.changeService = changeService;
exports.initNew = initNew;
exports.resetRequest = resetRequest;
exports.resetShopDetail = resetShopDetail;
exports.loadServiceByHandle = loadServiceByHandle;

var _localStorage = require('../../utils/localStorage');

var _ApiClient = require('../../helpers/ApiClient');

var _ApiServer = require('../../helpers/ApiServer');

var _support = require('helpers/support');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_SHOP_DETAIL = 'lookme/shops/LOAD_SHOP_DETAIL';
// import { clone } from 'lodash';

var LOAD_SHOP_DETAIL_SUCCESS = 'lookme/shops/LOAD_SHOP_DETAIL_SUCCESS';
var LOAD_SHOP_DETAIL_FAIL = 'lookme/shops/LOAD_SHOP_DETAIL_FAIL';
var LOAD_SHOP_DETAIL_SERVER = 'lookme/shops/LOAD_SHOP_DETAIL_SERVER';
var LOAD_SHOP_DETAIL_SERVER_SUCCESS = 'lookme/shops/LOAD_SHOP_DETAIL_SERVER_SUCCESS';
var LOAD_SHOP_DETAIL_SERVER_FAIL = 'lookme/shops/LOAD_SHOP_DETAIL_SERVER_FAIL';
var SHOP_LIKED_BOOKMARKED = 'lookme/shops/SHOP_LIKED_BOOKMARKED';
var NEW_REVIEW_SUBMITING = 'lookme/shops/NEW_REVIEW_SUBMITING';
var NEW_REVIEW_SUBMITTED = 'lookme/shops/NEW_REVIEW_SUBMITTED';
var UNSET = 'lookme/shops/UNSET';
var REPLY_SUBMITTED = 'REPLY_SUBMITTED';
var REPLY_SUBMITTING = 'REPLY_SUBMITTING';
var LOAD_DISTRICT = 'lookme/shops/LOAD_DISTRICT';
var LOAD_DISTRICT_SUCCESS = 'lookme/shops/LOAD_DISTRICT_SUCCESS';
var LOAD_DISTRICT_FAIL = 'lookme/shops/LOAD_DISTRICT_FAIL';
var INITNEW = 'lookme/shops/INITNEW';
var NEW = 'lookme/shops/NEW';
var NEW_SUCCESS = 'lookme/shops/NEW_SUCCESS';
var NEW_FAIL = 'lookme/shops/NEW_FAIL';
var PROMINENT = 'lookme/shops/PROMINENT';
var PROMINENT_SUCCESS = 'lookme/shops/PROMINENT_SUCCESS';
var PROMINENT_FAIL = 'lookme/shops/PROMINENT_FAIL';
var SUGGEST = 'lookme/shops/SUGGEST';
var SUGGEST_SUCCESS = 'lookme/shops/SUGGEST_SUCCESS';
var SUGGEST_FAIL = 'lookme/shops/SUGGEST_FAIL';
var HOME_SERVICE = 'lookme/shops/HOME_SERVICE';
var HOME_SERVICE_SUCCESS = 'lookme/shops/HOME_SERVICE_SUCCESS';
var HOME_SERVICE_FAIL = 'lookme/shops/HOME_SERVICE_FAIL';
var ACTIVE_BOOKING = 'lookme/shop/ACTIVE_BOOKING';
var ACTIVE_BOOKING_FAIL = 'lookme/shops/ACTIVE_BOOKING_FAIL';
var ACTIVE_BOOKING_SUCCESS = 'lookme/shops/ACTIVE_BOOKING_SUCCESS';
var FEATURED = 'lookme/shops/FEATURED';
var FEATURED_SUCCESS = 'lookme/shops/FEATURED_SUCCESS';
var FEATURED_FAIL = 'lookme/shops/FEATURED_FAIL';
var GET_BOOKING = 'lookme/shops/GET_BOOKING';
var GET_BOOKING_SUCCESS = 'lookme/shops/GET_BOOKING_SUCCESS';
var GET_BOOKING_FAIL = 'lookme/shops/GET_BOOKING_FAIL';
var CHECK_BOOKING = 'lookme/shops/CHECK_BOOKING';
var CHECK_BOOKING_SUCCESS = 'lookme/shops/CHECK_BOOKING_SUCCESS';
var CHECK_BOOKING_FAIL = 'lookme/shops/CHECK_BOOKING_FAIL';
var REQUEST_BOOKING = 'lookme/shops/REQUEST_BOOKING';
var REQUEST_BOOKING_SUCCESS = 'lookme/shops/REQUEST_BOOKING_SUCCESS';
var REQUEST_BOOKING_FAIL = 'lookme/shops/REQUEST_BOOKING_FAIL';
var RESET_REQUEST = 'lookme/shops/RESET_REQUEST';
var GENERAL_VIEW = 'lookme/shops/GENERAL_VIEW';
var GENERAL_VIEW_SUCCESS = 'lookme/shops/GENERAL_VIEW_SUCCESS';
var GENERAL_VIEW_FAIL = 'lookme/shops/GENERAL_VIEW_FAIL';
var LOAD_REVIEW_SUCCESS = 'lookme/shops/LOAD_REVIEW_SUCCESS';
var RESET_SHOP_DATA = 'lookme/shops/RESET_SHOP_DATA';
var RESET_SHOP_DETAIL = 'lookme/shops/RESET_SHOP_DETAIL';
var GET_REVIEW_SUGGEST = 'lookme/shops/GET_REVIEW_SUGGEST';
var GET_REVIEW_SUGGEST_SUCCESS = 'lookme/shops/GET_REVIEW_SUGGEST_SUCCESS';
var GET_REVIEW_SUGGEST_FAIL = 'lookme/shops/GET_REVIEW_SUGGEST_FAIL';

var LOAD_SERVICE_OF_HOME_SERVICE = 'lookme/shops/LOAD_SERVICE_OF_HOME_SERVICE';
var LOAD_SERVICE_OF_HOME_SERVICE_SUCCESS = 'lookme/shops/LOAD_SERVICE_OF_HOME_SERVICE_SUCCESS';
var LOAD_SERVICE_OF_HOME_SERVICE_FAIL = 'lookme/shops/LOAD_SERVICE_OF_HOME_SERVICE_FAIL';
var CHANGE_SERVICE = 'lookme/shops/CHANGE_SERVICE';

var LOAD_SERVICE_BY_HANDLE = 'lookme/shops/LOAD_SERVICE_BY_HANDLE';
var LOAD_SERVICE_BY_HANDLE_SUCCESS = 'lookme/shops/LOAD_SERVICE_BY_HANDLE_SUCCESS';
var LOAD_SERVICE_BY_HANDLE_FAIL = 'lookme/shops/LOAD_SERVICE_BY_HANDLE_FAIL';
var initialShop = {
  media: [],
  reviews: [],
  reviewLoad: {
    reviews: [],
    media: []
  },
  shop: null,
  loading_detail: false,
  loaded_detail: false
};
var initialState = (0, _extends3.default)({
  data: null,
  loadError: null,
  loaded: false,
  prominentLoading: false,
  prominentLoaded: false,
  featuredLoading: false,
  featuredLoaded: false,
  suggestLoading: false,
  suggestLoaded: false,
  homeServiceLoading: false,
  homeServiceLoaded: false,
  featured: [],
  homeService: [],
  suggests: [],
  prominents: [],
  reviewSuggest: []
}, initialShop, {
  creating: false,
  requested: false,
  requesting: false,
  messCreate: '',
  messRequest: '',
  SERVICE_OF_HOME_SERVICE: {
    loadding: true,
    data: [],
    error: null,
    fail: false
  },
  SERVICE_DETAIL: {
    loading: false,
    data: null,
    error: null,
    fail: false
  },
  submit: {
    bookingServices: []
  }
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_SHOP_DETAIL:
      return (0, _extends3.default)({}, state, {
        loading_detail: true
      });
    case LOAD_SHOP_DETAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading_detail: false,
        loaded_detail: true,
        shop: action.payload.shopData,
        reviews: action.payload.reviews,
        media: action.payload.media,
        reviewLoad: action.payload.reviewLoad
      });
    case LOAD_SHOP_DETAIL_FAIL:
      return (0, _extends3.default)({}, state, {
        loading_detail: false,
        loaded_detail: true,
        shop: null
      });
    case RESET_SHOP_DETAIL:
      return (0, _extends3.default)({}, state, initialShop);
    case LOAD_SHOP_DETAIL_SERVER:
      return (0, _extends3.default)({}, state, {
        loading_detail: true
      });
    case LOAD_SHOP_DETAIL_SERVER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading_detail: false,
        loaded_detail: true,
        shop: action.result
      });
    case LOAD_SHOP_DETAIL_SERVER_FAIL:
      return (0, _extends3.default)({}, state, {
        loading_detail: false,
        loaded_detail: true,
        shop: null
      });
    case LOAD_REVIEW_SUCCESS:
      {
        var reviewLoad = {};
        if (state.reviewLoad) {
          reviewLoad = (0, _extends3.default)({}, action.payload.reviewLoad, {
            reviews: [].concat((0, _toConsumableArray3.default)(state.reviewLoad.reviews), (0, _toConsumableArray3.default)(action.payload.reviewLoad.reviews))
          });
        }
        return (0, _extends3.default)({}, state, {
          loading_detail: false,
          loaded_detail: true,
          reviewLoad: reviewLoad
        });
      }
    case GET_BOOKING:
      return (0, _extends3.default)({}, state, {
        loading_booking: true,
        bookingDate: null
      });
    case GET_BOOKING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading_booking: false,
        loaded_booking: true,
        bookingDate: action.result
      });
    case GET_BOOKING_FAIL:
      return (0, _extends3.default)({}, state, {
        loading_booking: false,
        loaded_booking: true,
        bookingDate: null
      });
    case CHECK_BOOKING:
      return (0, _extends3.default)({}, state, {
        checkBooking: true,
        datesHaveBooking: null
      });
    case CHECK_BOOKING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        checkBooking: false,
        checkedbooking: true,
        datesHaveBooking: action.result.dates
      });
    case CHECK_BOOKING_FAIL:
      return (0, _extends3.default)({}, state, {
        checkBooking: false,
        checkedbooking: true,
        datesHaveBooking: null
      });
    case REQUEST_BOOKING:
      return (0, _extends3.default)({}, state, {
        requesting: true,
        requested: false
      });
    case REQUEST_BOOKING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        requesting: false,
        requested: true,
        messRequest: action.result.mess
      });
    case REQUEST_BOOKING_FAIL:
      return (0, _extends3.default)({}, state, {
        requesting: false,
        requested: true,
        errorsRequest: action.error.errors
      });
    case RESET_REQUEST:
      return (0, _extends3.default)({}, state, {
        requesting: false,
        requested: false,
        messRequest: ''
      });
    case SHOP_LIKED_BOOKMARKED:
      return (0, _extends3.default)({}, state, {
        shop: action.payload
      });
    case NEW_REVIEW_SUBMITING:
      {
        return (0, _extends3.default)({}, state, {
          loading: true
        });
      }
    case NEW_REVIEW_SUBMITTED:
      {
        return (0, _extends3.default)({}, state, {
          loading: false,
          reviews: action.payload
        });
      }
    case REPLY_SUBMITTING:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case REPLY_SUBMITTED:
      return (0, _extends3.default)({}, state, {
        loading: false,
        reviews: action.payload
      });
    case PROMINENT:
      return (0, _extends3.default)({}, state, {
        prominentLoading: true
      });
    case PROMINENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        prominentLoading: false,
        prominents: action.result,
        prominentError: null,
        prominentLoaded: true
      });
    case PROMINENT_FAIL:
      {
        if (typeof action.error === 'string') {
          return (0, _extends3.default)({}, state, {
            prominentLoading: false,
            prominentError: action.error,
            prominentLoaded: true
          });
        }
        return state;
      }
    case HOME_SERVICE:
      return (0, _extends3.default)({}, state, {
        homeServiceLoading: true
      });
    case HOME_SERVICE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        homeServiceLoading: false,
        homeService: action.result,
        homeServiceError: null,
        homeServiceLoaded: true
      });
    case HOME_SERVICE_FAIL:
      {
        if (typeof action.error === 'string') {
          return (0, _extends3.default)({}, state, {
            homeServiceLoading: false,
            homeServiceError: action.error,
            ahomeServiceLoaded: true
          });
        }
        return state;
      }
    case LOAD_SERVICE_OF_HOME_SERVICE:
      return (0, _extends3.default)({}, state, {
        SERVICE_OF_HOME_SERVICE: {
          loading: true,
          data: [],
          fail: false
        }
      });
    case LOAD_SERVICE_OF_HOME_SERVICE_SUCCESS:
      {
        if (action.result && action.result.data) {
          var services = _support.Helper.groupServicesToHomeServices(action.result.data);
          return (0, _extends3.default)({}, state, {
            SERVICE_OF_HOME_SERVICE: {
              data: services,
              loading: false,
              fail: false,
              error: null
            }
          });
        }
        return state;
      }
    case LOAD_SERVICE_OF_HOME_SERVICE_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          SERVICE_OF_HOME_SERVICE: {
            loading: false,
            data: [],
            fail: true,
            error: action.error
          }
        });
      }
    case SUGGEST:
      return (0, _extends3.default)({}, state, {
        suggestLoading: true
      });
    case SUGGEST_SUCCESS:
      return (0, _extends3.default)({}, state, {
        suggestLoading: false,
        suggests: action.result,
        suggestError: null,
        suggestLoaded: true
      });
    case SUGGEST_FAIL:
      {
        if (typeof action.error === 'string') {
          return (0, _extends3.default)({}, state, {
            suggestLoading: false,
            suggestError: action.error,
            suggestLoaded: true
          });
        }
      }
    case ACTIVE_BOOKING:
      return (0, _extends3.default)({}, state, {
        activeBookingLoading: true
      });
    case ACTIVE_BOOKING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        activeBookingLoading: false,
        activeBooking: action.result,
        activeBookingError: null,
        activeBookingLoaded: true
      });
    case ACTIVE_BOOKING_FAIL:
      {
        if (typeof action.error === 'string') {
          return (0, _extends3.default)({}, state, {
            activeBookingLoading: false,
            activeBookingError: action.error,
            activeBookingLoaded: true
          });
        }
        return state;
      }
    case FEATURED:
      return (0, _extends3.default)({}, state, {
        featuredLoading: true
      });
    case FEATURED_SUCCESS:
      return (0, _extends3.default)({}, state, {
        featuredLoading: false,
        featured: action.result,
        featuredError: null,
        featuredLoaded: true
      });
    case FEATURED_FAIL:
      {
        if (typeof action.error === 'string') {
          return (0, _extends3.default)({}, state, {
            featuredLoading: false,
            featuredError: action.error,
            featuredLoaded: true
          });
        }
        return state;
      }
    case GENERAL_VIEW:
      return (0, _extends3.default)({}, state, {
        generalViewLoading: true
      });
    case GENERAL_VIEW_SUCCESS:
      return (0, _extends3.default)({}, state, {
        generalViewLoading: false,
        generalView: action.result,
        generalViewError: null,
        generalViewLoaded: true
      });
    case GENERAL_VIEW_FAIL:
      {
        if (typeof action.error === 'string') {
          return (0, _extends3.default)({}, state, {
            generalViewLoading: false,
            generalViewError: action.error,
            generalViewLoaded: true
          });
        }
        return state;
      }
    case UNSET:
      return (0, _extends3.default)({}, state, {
        detail: null,
        reviews: [],
        media: []
      });
    case RESET_SHOP_DATA:
      return {
        shop: null
      };
    case INITNEW:
      return (0, _extends3.default)({}, state, {
        created: false
      });
    case NEW:
      return (0, _extends3.default)({}, state, {
        creating: true,
        created: false
      });
    case NEW_SUCCESS:
      return (0, _extends3.default)({}, state, {
        created: true,
        creating: false,
        messCreate: action.result.mess,
        errorsCreate: null
      });
    case NEW_FAIL:
      return (0, _extends3.default)({}, state, {
        creating: false,
        created: false,
        errorsCreate: action.error.errors
      });
    case LOAD_DISTRICT:
      return (0, _extends3.default)({}, state, {
        districtLoading: true,
        districtParent: action.provinceCode
      });
    case LOAD_DISTRICT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        districtLoading: false,
        districts: action.result,
        addressFilter: [],
        loadDistrictError: null,
        district_loaded: true
      });
    case LOAD_DISTRICT_FAIL:
      {
        if (typeof action.error === 'string') {
          return (0, _extends3.default)({}, state, {
            districtLoading: false,
            loadDistrictError: action.error,
            district_loaded: true
          });
        }
        return state;
      }
    case CHANGE_SERVICE:
      {
        var service = action.service;
        var bookingServices = [];
        // if (state.submit.bookingServices && state.submit.bookingServices.length) {
        //   for (
        //     let i = 0, len = state.submit.bookingServices.length;
        //     i < len;
        //     i++
        //   ) {
        //     const item = clone(state.submit.bookingServices[i]);
        //     bookingServices.push(item);
        //   }
        // }
        if (service) {
          // const number = service.number;
          // if (number === 0) {
          //   bookingServices = Helper.removeServices(bookingServices, service);
          // } else {
          //   bookingServices = Helper.updateServices(bookingServices, service);
          // }
          bookingServices.push(service);
        }
        return (0, _extends3.default)({}, state, {
          submit: (0, _extends3.default)({}, state.submit, {
            bookingServices: bookingServices
          })
        });
      }
    case GET_REVIEW_SUGGEST_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          reviewSuggest: action.result
        });
      }
    case LOAD_SERVICE_BY_HANDLE:
      {
        return (0, _extends3.default)({}, state, {
          SERVICE_DETAIL: (0, _extends3.default)({}, state.SERVICE_DETAIL, {
            loading: true
          })
        });
      }
    case LOAD_SERVICE_BY_HANDLE_SUCCESS:
      {
        console.log('LOAD_SERVICE_BY_HANDLE_SUCCESS', action);
        return (0, _extends3.default)({}, state, {
          SERVICE_DETAIL: (0, _extends3.default)({}, state.SERVICE_DETAIL, {
            data: action.result,
            error: null,
            loading: false,
            fail: false
          })
        });
      }
    case LOAD_SERVICE_BY_HANDLE_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          SERVICE_DETAIL: (0, _extends3.default)({}, state.SERVICE_DETAIL, {
            loading: false,
            data: null,
            error: action.error,
            fail: true
          })
        });
      }
    default:
      return state;
  }
}

function parseUrl(query) {
  if (query === undefined) {
    return '';
  }
  var array = [];
  for (var key in query) {
    if (query.hasOwnProperty(key)) {
      array.push(key + '=' + query[key]);
    }
  }
  return array.join('&');
}

function isLoaded(globalState) {
  return globalState.shops && globalState.shops.loaded;
}

function isLoadedDetail(globalState) {
  return globalState.shops && globalState.shops.loaded_detail;
}

function isProminentLoaded(globalState) {
  return globalState.shops && globalState.shops.prominentLoaded;
}

function isSuggestLoaded(globalState) {
  return globalState.shops && globalState.shops.suggestLoaded;
}

function isFeaturedLoaded(globalState) {
  return globalState.shops && globalState.shops.featuredLoaded;
}

// export function load() {
//   return {
//     types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
//     promise: (client) => client.get('/shop/load')
//   };
// }

function unSetDetail() {
  return {
    type: UNSET
  };
}

function getProminent(filter) {
  var isHome = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var query = {
    page: 1,
    pageSize: 4,
    sort: 'prominent',
    sortTo: false,
    home: isHome
  };
  if (filter) {
    query.page = filter.page ? filter.page : 1;
    query.pageSize = filter.pageSize ? filter.pageSize : 4;
    query.province = filter.province;
    query.category = filter.category;
  }
  var url = parseUrl(query);
  return {
    types: [PROMINENT, PROMINENT_SUCCESS, PROMINENT_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/shop/load?' + url);
    }
  };
}
function getSuggest(filter) {
  var query = {
    page: 1,
    pageSize: 4,
    sort: 'suggest',
    sortTo: false
  };
  if (filter) {
    query.page = filter.page ? filter.page : 1;
    query.pageSize = filter.pageSize ? filter.pageSize : 4;
    query.province = filter.province;
    query.category = filter.category;
  }
  var url = parseUrl(query);
  return {
    types: [SUGGEST, SUGGEST_SUCCESS, SUGGEST_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/shop/load?' + url);
    }
  };
}

function getHomeService(filter) {
  var query = {
    page: 1,
    pageSize: 4,
    sortTo: false
  };
  if (filter) {
    query.page = filter.page ? filter.page : 1;
    query.pageSize = filter.pageSize ? filter.pageSize : 4;
    query.province = filter.province;
    // query.category = filter.category;
    query.atHome = true;
  }
  var url = parseUrl(query);
  return {
    types: [HOME_SERVICE, HOME_SERVICE_SUCCESS, HOME_SERVICE_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/shop/load?' + url);
    }
  };
}

function loadServiceOfHomeService(shopId) {
  return {
    types: [LOAD_SERVICE_OF_HOME_SERVICE, LOAD_SERVICE_OF_HOME_SERVICE_SUCCESS, LOAD_SERVICE_OF_HOME_SERVICE_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/service/loadAllForBooking?shopId=' + shopId);
    }
  };
}

function getActiveBooking(filter) {
  var query = {
    page: 1,
    pageSize: 4,
    sortTo: false
  };
  if (filter) {
    query.page = filter.page ? filter.page : 1;
    query.pageSize = filter.pageSize ? filter.pageSize : 4;
    query.province = filter.province;
    query.category = filter.category;
  }
  var url = parseUrl(query);
  return {
    types: [ACTIVE_BOOKING, ACTIVE_BOOKING_SUCCESS, ACTIVE_BOOKING_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/shop/loadAllActiveBooking?' + url);
    }
  };
}

function getGeneralView(filter, id) {
  var query = {
    page: 1,
    pageSize: 8
  };
  if (filter) {
    query.page = filter.page ? filter.page : 1;
    query.pageSize = filter.pageSize ? filter.pageSize : 8;
    query.province = filter.province;
    query.category = filter.category;
  }
  var url = parseUrl(query);
  return {
    types: [GENERAL_VIEW, GENERAL_VIEW_SUCCESS, GENERAL_VIEW_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/shop/get-general-view/' + id + '?' + url);
    }
  };
}

function getFeatured(filter) {
  var query = {
    page: 1,
    pageSize: 8,
    sort: 'nearby'
  };
  if (filter) {
    query.page = filter.page ? filter.page : 1;
    query.pageSize = filter.pageSize ? filter.pageSize : 8;
    query.province = filter.province;
    query.category = filter.category;
    if (filter.location) {
      query.lat = filter.location.latitude;
      query.lng = filter.location.longitude;
    }
  }
  var url = parseUrl(query);
  return {
    types: [FEATURED, FEATURED_SUCCESS, FEATURED_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/shop/load?' + url);
    }
  };
}

function getReview(page, shopId) {
  var _this = this;

  var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
      var reviewLoad;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: LOAD_SHOP_DETAIL
              });
              _context.next = 3;
              return _ApiClient.client.get('/review/load/' + shopId + '?pageSize=' + pageSize + '&page=' + page);

            case 3:
              reviewLoad = _context.sent;

              if (reviewLoad) {
                dispatch({
                  type: LOAD_REVIEW_SUCCESS,
                  payload: { reviewLoad: reviewLoad }
                });
              } else {
                dispatch({
                  type: LOAD_SHOP_DETAIL_FAIL
                });
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x5) {
      return _ref.apply(this, arguments);
    };
  }();
}

function getShopData(handle) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
      var shopData, shopId, reviewLoad;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch({
                type: LOAD_SHOP_DETAIL
              });
              _context2.next = 3;
              return _ApiClient.client.get('/shop/get-by-handle/' + handle);

            case 3:
              shopData = _context2.sent;

              if (!shopData) {
                _context2.next = 12;
                break;
              }

              shopId = shopData._id;
              _context2.next = 8;
              return _ApiClient.client.get('/review/load/' + shopId);

            case 8:
              reviewLoad = _context2.sent;

              dispatch({
                type: LOAD_SHOP_DETAIL_SUCCESS,
                payload: {
                  shopData: shopData,
                  reviews: reviewLoad.reviews.reverse(),
                  reviewLoad: reviewLoad,
                  media: reviewLoad.media.reverse()
                }
              });
              _context2.next = 13;
              break;

            case 12:
              dispatch({
                type: LOAD_SHOP_DETAIL_FAIL
              });

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function (_x6) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function resetShopData() {
  return {
    type: RESET_SHOP_DATA
  };
}

function getShopDataServer(handle) {
  var _this3 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch) {
      var shopData, shopId, reviewLoad;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch({
                type: LOAD_SHOP_DETAIL
              });
              _context3.next = 3;
              return _ApiServer.server.get('/shop/get-by-handle/' + handle);

            case 3:
              shopData = _context3.sent;

              if (!shopData) {
                _context3.next = 12;
                break;
              }

              shopId = shopData._id;
              _context3.next = 8;
              return _ApiServer.server.get('/review/load/' + shopId);

            case 8:
              reviewLoad = _context3.sent;

              dispatch({
                type: LOAD_SHOP_DETAIL_SUCCESS,
                payload: {
                  shopData: shopData,
                  reviews: reviewLoad.reviews.reverse(),
                  reviewLoad: reviewLoad,
                  media: reviewLoad.media.reverse()
                }
              });
              _context3.next = 13;
              break;

            case 12:
              dispatch({
                type: LOAD_SHOP_DETAIL_FAIL
              });

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }));

    return function (_x7) {
      return _ref3.apply(this, arguments);
    };
  }();
  // return {
  //   types: [LOAD_SHOP_DETAIL_SERVER, LOAD_SHOP_DETAIL_SERVER_SUCCESS, LOAD_SHOP_DETAIL_SERVER_FAIL],
  //   promise: () => server.get('/shop/get-by-handle/' + handle)
  // };
}

function checkBooking(shop) {
  return {
    types: [CHECK_BOOKING, CHECK_BOOKING_SUCCESS, CHECK_BOOKING_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/booking/bookingIn2Week?shop=' + shop);
    }
  };
}

function getReviewSuggest() {
  return {
    types: [GET_REVIEW_SUGGEST, GET_REVIEW_SUGGEST_SUCCESS, GET_REVIEW_SUGGEST_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/review/suggest');
    }
  };
}
function getBooking(shop, date) {
  var dateParse = date ? (0, _moment2.default)(new Date(date)).format('YYYY-MM-DD') : (0, _moment2.default)(new Date()).format('YYYY-MM-DD');
  return {
    types: [GET_BOOKING, GET_BOOKING_SUCCESS, GET_BOOKING_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/booking/loadOneBookingByDate/' + shop + '/' + dateParse);
    }
  };
}

function requestBooking(data) {
  return {
    types: [REQUEST_BOOKING, REQUEST_BOOKING_SUCCESS, REQUEST_BOOKING_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.post('/booking/request', {
        data: data
      });
    }
  };
}

function likeShop(shopId) {
  var _this4 = this;

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
      var data, shop;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              data = {
                shopId: shopId,
                token: (0, _localStorage.localStore)().get('token')
              };
              shop = (0, _extends3.default)({}, getState().shops.shop);

              shop.isLiked = !shop.isLiked;
              dispatch({
                type: SHOP_LIKED_BOOKMARKED,
                payload: shop
              });
              _context4.next = 6;
              return _ApiClient.client.post('/shop/like', {
                data: data
              });

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }));

    return function (_x8, _x9) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function bookmarkShop(shopId) {
  var _this5 = this;

  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch, getState) {
      var data, shop;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              data = {
                shopId: shopId,
                token: (0, _localStorage.localStore)().get('token')
              };
              shop = (0, _extends3.default)({}, getState().shops.shop);

              shop.isBookmarked = !shop.isBookmarked;
              dispatch({
                type: SHOP_LIKED_BOOKMARKED,
                payload: shop
              });
              _context5.next = 6;
              return _ApiClient.client.post('/shop/bookmark', {
                data: data
              });

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }));

    return function (_x10, _x11) {
      return _ref5.apply(this, arguments);
    };
  }();
}

function newReview(data, images) {
  var _this6 = this;

  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch, getState) {
      var attach, submitNewReviewResponse, reviews;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              dispatch({
                type: NEW_REVIEW_SUBMITING
              });
              attach = void 0;

              attach = [];
              images.map(function (img) {
                var obj = {
                  key: 'img',
                  value: img
                };
                attach.push(obj);
              });
              data.token = (0, _localStorage.localStore)().get('token');
              _context6.next = 7;
              return _ApiClient.client.post('/review/new', {
                data: data,
                attach: attach
              });

            case 7:
              submitNewReviewResponse = _context6.sent;

              if (submitNewReviewResponse.success) {
                reviews = getState().shops.reviews.slice(0);

                reviews.unshift(submitNewReviewResponse.review);
                dispatch({
                  type: NEW_REVIEW_SUBMITTED,
                  payload: reviews
                });
              }

            case 9:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }));

    return function (_x12, _x13) {
      return _ref6.apply(this, arguments);
    };
  }();
}

function submitReply(msg, reviewId) {
  var _this7 = this;

  return function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch, getState) {
      var data, replyResponse, reviews, indexReview;
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch({
                type: REPLY_SUBMITTING
              });
              data = {
                message: msg,
                reviewId: reviewId,
                token: (0, _localStorage.localStore)().get('token')
              };
              _context7.next = 4;
              return _ApiClient.client.post('/review/reply', {
                data: data
              });

            case 4:
              replyResponse = _context7.sent;
              reviews = getState().shops.reviews.slice(0);
              indexReview = reviews.findIndex(function (review) {
                return review._id === replyResponse.review._id;
              });

              reviews[indexReview] = replyResponse.review;
              dispatch({
                type: REPLY_SUBMITTED,
                payload: reviews
              });

            case 9:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }));

    return function (_x14, _x15) {
      return _ref7.apply(this, arguments);
    };
  }();
}

function loadDistrict(province) {
  return {
    types: [LOAD_DISTRICT, LOAD_DISTRICT_SUCCESS, LOAD_DISTRICT_FAIL],
    provinceCode: province,
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/address/load-district?province_code=' + province);
    }
  };
}

function createShop(data, images) {
  var attach = [];
  images.map(function (img) {
    var obj = {
      key: 'img',
      value: img
    };
    attach.push(obj);
  });
  return {
    types: [NEW, NEW_SUCCESS, NEW_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.post('/shop/create', {
        data: data,
        attach: attach
      });
    }
  };
}
function changeService(service) {
  return {
    type: CHANGE_SERVICE,
    service: service
  };
}
function initNew() {
  return {
    type: INITNEW
  };
}

function resetRequest() {
  return {
    type: RESET_REQUEST
  };
}

function resetShopDetail() {
  return { type: RESET_SHOP_DETAIL };
}

function loadServiceByHandle(handle) {
  return {
    types: [LOAD_SERVICE_BY_HANDLE, LOAD_SERVICE_BY_HANDLE_SUCCESS, LOAD_SERVICE_BY_HANDLE_FAIL],
    promise: function promise(clientMiddleware) {
      return clientMiddleware.get('/service/getOneByHandle/' + handle);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/shops.js
// module id = 23
// module chunks = 0